import * as actionTypes from '@/store/action-types'
import * as mutationTypes from '@/store/mutation-types'
import Information from '@/api/quiz/Information'
import Answer from '@/api/quiz/Answer'
import CountUpHintView from '@/api/quiz/CountUpHintView'
import Util from '@/modules/Util'
import * as LoadingWaitTypes from '@/constants/LoadingWaitTypes'

export default {
  /**
   * 初回セットアップ
   * @param commit
   * @param token
   * @returns {Q.Promise<any>}
   */
  [actionTypes.setUp] ({ commit }, { token }) {
    const params = Information.makeParam(token)
    const informationApi = new Information()
    return informationApi.post(params)
      .then((response) => {
        const res = Number(response.data.res)
        if (res !== 0) {
          throw new Error(`api response error res:${res} response${JSON.stringify(response.data)}`)
        }
        commit(mutationTypes.setUp, {
          information: response.data
        })
        if (response.data.is_login) {
          commit(mutationTypes.login)
        } else {
          commit(mutationTypes.logout)
        }
        commit(mutationTypes.offLoadingWait, {
          loading_wait_type: LoadingWaitTypes.INITIALIZE
        })
      })
      .catch((error) => {
        console.log(`informationApi error:${error}`)
      })
  },
  /**
   * 回答
   * @param commit
   * @param getters
   * @param token
   * @param qmId
   * @param qsmId
   * @returns {Q.Promise<any>}
   */
  [actionTypes.answer] ({ commit, getters }, { token, qmId, qsmId }) {
    const params = Answer.makeParam(token, qmId, qsmId)
    const answerApi = new Answer()
    console.log(`actionTypes.answer qmId:${qmId} qsmId:${qsmId}`)
    return answerApi.post(params)
      .then((response) => {
        const res = Number(response.data.res)
        if (res !== 0) {
          throw new Error(`api response error res:${res} response${JSON.stringify(response.data)}`)
        }
        console.log(`response.data:${response.data}`)
        console.log(`response.data:${JSON.stringify(response.data)}`)
        console.log(`response.data.incorrect_information:${response.data.incorrect_information}`)
        if (response.data.is_correct) {
          commit(mutationTypes.setResultCorrectInformation, {
            correctInformation: response.data.correct_information
          })
        } else {
          commit(mutationTypes.setResultIncorrectInformation, {
            incorrectInformation: response.data.incorrect_information
          })
        }
        commit(mutationTypes.updateUqList, {
          uqList: response.data.uq_list
        })
        commit(mutationTypes.updatePoint, {
          point: response.data.point
        })

        // 表示問題数を調べて、1つも無いようならページを一つ下げる
        let qmList = {}
        if (getters.isUnansweredListView) {
          qmList = getters.unansweredInformation.qm_list
        } else {
          qmList = getters.answeredInformation.qm_list
        }
        const tmpLimitedQmList = Util.limitedQmList(getters.pageNumber, qmList)
        const tmpLimitedQmListKeys = Object.keys(tmpLimitedQmList)
        if (tmpLimitedQmListKeys.length <= 0) {
          let pageNumber = Math.max(getters.pageNumber - 1, 1)
          commit(mutationTypes.setPageNumber, {
            pageNumber
          })
        }
      })
      .catch((error) => {
        console.log(`answerApi error:${error}`)
      })
  },
  /**
   * ヒント閲覧数カウントアップ
   * @param commit
   * @param token
   * @param qmId
   * @returns {Q.Promise<any>}
   */
  [actionTypes.countUpHintView] ({ commit }, { token, qmId }) {
    const params = CountUpHintView.makeParam(token, qmId)
    const countUpHintView = new CountUpHintView()

    return countUpHintView.post(params)
      .then((response) => {
        const res = Number(response.data.res)
        if (res !== 0) {
          throw new Error(`api response error res:${res} response${JSON.stringify(response.data)}`)
        }
        console.log(`response.data:${response.data}`)
        console.log(`response.data:${JSON.stringify(response.data)}`)
      })
      .catch((error) => {
        console.log(`countUpHintViewApi error:${error}`)
      })
  }
}
